export class BlobUtils {
    static downloadBlob(blob: Blob, fileName: string) {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = fileName;
        link.click();
    }
}
